module.exports = __webpack_public_path__ + "media/images/demo/dark-sidebar-70a32903644457ac29049205260cf7e6.jpg";